import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { StopwatchProvider } from "./components/StickyStopwatch/StopwatchContext";
import * as Sentry from "@sentry/react";

const environment = process.env.REACT_APP_ENVIRONMENT_LEVEL || "ENV-NOT-SET";
const sentryDsn = process.env.REACT_APP_SENTRY_DSN || "SENTRY-DSN-NOT-SET";

Sentry.init({
  dsn: sentryDsn,
  environment: environment,
  enabled: environment !== "development",
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <StopwatchProvider>
    <App />
  </StopwatchProvider>,
);

serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
